<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-breadcrumbs :items="breadcrumbs">
                        <template v-slot:divider>
                            <v-icon>chevron_right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="12" md="6">
                    <v-card>
                        <v-card-title>
                            <b>New Service</b>
                        </v-card-title>
                        <v-card-text class="text--primary">
                            <service-form context="create"
                                          :service="serviceFormData('create')"
                                         @validation-changed="handleFormValidationChanged"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" :disabled="!createButtonActive" @click="handleCreateButtonClick"
                                   :loading="progress('createService')">
                                Create
                            </v-btn>
                            <v-btn @click="handleCancelButtonClick">
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapState, mapGetters} from 'vuex'
    import ServiceForm from '../Components/ServiceForm'
    export default {
        name: 'CreateService',
        components: {
            ServiceForm,
        },
        data() {
            return {
                breadcrumbs: [
                    {
                        text: 'Services',
                        disabled: false,
                        href: '#/services'
                    },
                    {
                        text: 'Create',
                        disabled: true,
                        href: '#/services/create'
                    }
                ],
            }
        },
        computed: {
            ...mapGetters('services', {
                progress: 'progress',
                serviceFormData: 'serviceFormData',
                isServiceFormValid: 'isServiceFormValid'
            }),
            createButtonActive () {
                return this.isServiceFormValid('create') && !this.progress('createService')
            }
        },
        created() {
            this.initCreateServiceFormData()
        },
        methods: {
            ...mapActions({
                createService: 'services/createService',
                initCreateServiceFormData: 'services/initCreateServiceFormData',
                changeServiceFormValidation: 'services/changeServiceFormValidation',
                resetServiceFormData: 'services/resetServiceFormData'
            }),
            async handleCreateButtonClick () {
                const creationResult = await this.createService()

                if (!creationResult) {
                    return
                }

                this.resetServiceFormData()
                this.$router.push('/services')
            },
            handleCancelButtonClick () {
                this.resetServiceFormData()
                this.$router.push('/services')
            },
            handleFormValidationChanged (value) {
                this.changeServiceFormValidation(value)
            }
        }
    }
</script>

<style scoped>

</style>